// @core/api/endpoints/team/list_team_join_applications.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListTeamJoinApplicationsResponse,
} from '../../../types/team';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/team';

/**
 * List join applications
 * Returns all pending join applications for a team. Only team admins can view the full list.
 */
export async function ListTeamJoinApplications(
  team_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListTeamJoinApplicationsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/join-applications`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.get<ListTeamJoinApplicationsResponse>(requestPath, { ...requestOptions, params });
}
